import { ComplaintIcon } from '@modules/common/components/CategoryIcon/ComplaintIcon';
import { HelpIcon } from '@modules/common/components/CategoryIcon/HelpIcon';
import { ImprovementIcon } from '@modules/common/components/CategoryIcon/ImprovementIcon';
import { PraiseIcon } from '@modules/common/components/CategoryIcon/PraiseIcon';
import { Category } from '@modules/common/types';
import { Box } from '@mui/material';

interface CategoryIconProps {
  category: Category | null;
  size?: number;
  fill?: string;
}

export const CategoryIcon = ({
  category,
  size = 16,
  fill,
}: CategoryIconProps) => {
  if (!category) {
    return null;
  }

  const getCategoryIcon = () => {
    switch (category) {
      case Category.Help:
        return <HelpIcon width={size} height={size} fill={fill} />;
      case Category.Complaint:
        return <ComplaintIcon width={size} height={size} fill={fill} />;
      case Category.Praise:
        return <PraiseIcon width={size} height={size} fill={fill} />;
      case Category.Improvement:
        return <ImprovementIcon width={size} height={size} fill={fill} />;
      default:
        return (
          <Box
            sx={{
              width: size,
              height: size,
              borderRadius: '50%',
              borderStyle: 'dashed',
              color: 'text.secondary',
              boxSizing: 'content-box',
            }}
          />
        );
    }
  };

  return <>{getCategoryIcon()}</>;
};
